export enum ProductiveCycleEnum {
  PRIMERA = 'PRIMERA',
  POSTRERA = 'POSTRERA',
  POSTRERA_TARDIA = 'POSTRERA_TARDIA',
  TODOS_LOS_CICLOS = 'TODOS_LOS_CICLOS',
  CONVENIO_ANUAL = 'CONVENIO_ANUAL',
  OTHER = 'OTHER',
}